import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export class ModelLoader {
  constructor(callback) {
    this.loader = new GLTFLoader();
    this.models = {};
    this.readyCallback = callback;
    this.loadModels();
  }

  loadModels() {
    const modelList = [
      { name: 'pickaxe', path: '/models/pickaxe.glb' },
      // { name: 'axe', path: '/models/axe.glb' },
      // { name: 'shovel', path: '/models/shovel.glb' }
    ];

    let loadedCount = 0;
    modelList.forEach(model => {
      this.loader.load(model.path, gltf => {
        this.models[model.name] = gltf.scene;
        loadedCount++;
        if (loadedCount === modelList.length) {
          this.readyCallback(this.models);
        }
      }, undefined, error => {
        console.error(`Model load error for ${model.name}:`, error);
      });
    });
  }

  get(name) {
    return this.models[name]?.clone() || null;
  }
}
